export {default as PeopleReportWithTabsRenderer} from './PeopleReportWithTabsRenderer.connect';
